(function (mod) {
	if (typeof exports === "object") { //browserify
		module.exports = mod();
	}else{ //html script tag
		window.Q = mod();
	}
})(function (){
var Mo = (function (){

/////////////////////////////////////////////////////////////////////////
// ↓ DEBUG TOOL ↓
/////////////////////////////////////////////////////////////////////////
var DEBUG = true;
//var isC1 = (!window.console)? false : true;
//var isC2 = (typeof console.log != "undefined")? true : false;
//var isCon = (isC1&&isC2)? true : false;
var isCon = (!window.console)? false : true;
	
function check(){
	var A = (DEBUG && isCon)? true : false;
	return A;
}

function _mode(m){
	DEBUG = m;
}

function _log() {
	if (check()){
		for (var i = 0; i < arguments.length; i++) {
			console.log(arguments[i]);
		}
	}
}
function _info() {
	if (check()){
		for (var i = 0; i < arguments.length; i++) {
			console.info(arguments[i]);
		}
	}
}
function _warn() {
	if (check()){
		for (var i = 0; i < arguments.length; i++) {
			console.warn(arguments[i]);
		}
	}
}
function _error() {
	if (check()){
		for (var i = 0; i < arguments.length; i++) {
			console.error(arguments[i]);
		}
	}
}
function _debug() {
	if (check()){
		for (var i = 0; i < arguments.length; i++) {
			console.debug(arguments[i]);
		}
	}
}
function _count(s) {if (check()){ console.count(s);}}
function _time(s) {if (check()){ console.time(s);}}
function _timeEnd(s) {if (check()){ console.timeEnd(s);}}
function _trace(s) {if (check()){ console.trace(s);}}
function _trace(s) {if (check()){ console.trace(s);}}
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
return {
	Q : check(),
	mode : _mode,
	log : _log,
	info : _info,
	warn : _warn,
	error : _error,
	debug : _debug,
	count : _count,
	time : _time,
	timeEnd: _timeEnd,
	trace : _trace
};
/////////////////////////////////////////////////////////////////////////

})();
return Mo;
});



